import { render } from "./Logs.vue?vue&type=template&id=4c897cbc&scoped=true"
import script from "./Logs.vue?vue&type=script&lang=js"
export * from "./Logs.vue?vue&type=script&lang=js"

import "./Logs.vue?vue&type=style&index=0&id=4c897cbc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4c897cbc"

export default script